import * as React from 'react';
import { cn } from '@/lib/utils';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => (
    <textarea
      className={cn(
        'flex min-h-[80px] w-full resize-y rounded-lg border border-input bg-white px-3 py-2 text-sm placeholder:text-muted-foreground/70',
        'focus-visible:border-[#70aa96] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-success/10',
        'disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-70 aria-[invalid=true]:border-destructive',
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';

export { Textarea };
